import type { Option } from '../remote-freelancer/use-get-certificate-types';

type UseGetCertificateOptionsHandler = {
  certificateOptions: Option[];
};

const useGetCertificateOptions = (): UseGetCertificateOptionsHandler => {
  const certificateOptions = [
    { label: 'BHV Verplicht', value: 'bhv' },
    { label: 'EHBO Verplicht', value: 'ehbo' },
    { label: 'VVE Certificaat', value: 'vve' },
    { label: 'Taaleis 3F', value: 'taaleis' },
    { label: 'Baby Training', value: 'baby' },
  ];

  return {
    certificateOptions,
  };
};

export default useGetCertificateOptions;
